import useSWR from 'swr';
import { getApi3Endpoint } from '../utils/links.es.js';
import { SwrFetcher } from '../utils/swr.es.js';
import { EventIds } from '../constants/EventIds.es.js';
import { usePricingContext } from '../contexts/PricingProvider/PricingContext.es.js';

var BundleCatalogPath = '/subscription/api/v1/catalog/bundles';
var useBundleCatalog = function useBundleCatalog() {
  var _usePricingContext = usePricingContext(),
    env = _usePricingContext.env,
    log = _usePricingContext.log,
    authorizationToken = _usePricingContext.authorizationToken;
  var _useSWR = useSWR([getApi3Endpoint(env, BundleCatalogPath), authorizationToken], SwrFetcher, {
      revalidateOnFocus: false,
      onError: function onError(error) {
        log.error('Unable to fetch bundle catalog', EventIds.BundleCatalogLoadDataFail, error);
      }
    }),
    data = _useSWR.data,
    error = _useSWR.error;
  return {
    data: data,
    loading: !error && !data,
    error: error
  };
};

export { BundleCatalogPath, useBundleCatalog };
